// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blood-chemistry-extractor .ant-row + .ant-row {
  margin-top: 32px;
}
.blood-chemistry-extractor .page-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 32px 0;
  background: var(--gradient-glass);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
}
.blood-chemistry-extractor .page-header:hover {
  box-shadow: var(--shadow-float);
  transform: translateY(-2px);
}
.blood-chemistry-extractor .page-header .ant-typography {
  margin-bottom: 0;
  color: #1e293b;
}
.blood-chemistry-extractor .ant-alert {
  border-radius: 12px;
  border: none;
  box-shadow: var(--shadow-sm);
}
.blood-chemistry-extractor .ant-alert.ant-alert-info {
  background: rgba(224, 242, 254, 0.6);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(186, 230, 253, 0.5);
}
.blood-chemistry-extractor .ant-card .ant-card-head {
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.blood-chemistry-extractor .ant-card .ant-card-head .ant-card-head-title {
  color: #334155;
  font-weight: 600;
  font-size: 16px;
}
.blood-chemistry-extractor .ant-card .ant-card-body {
  padding: 24px;
}
.blood-chemistry-extractor .ant-card .ant-card-body ul li {
  margin-bottom: 8px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}
.blood-chemistry-extractor .ant-card .ant-card-body ul li:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .blood-chemistry-extractor .ant-col {
    margin-bottom: 16px;
  }
  .blood-chemistry-extractor .page-header {
    padding: 20px;
    margin-bottom: 20px;
  }
  .blood-chemistry-extractor .page-header .ant-typography h2 {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/BloodChemistryExtractor.less"],"names":[],"mappings":"AAAA;EAII,gBAAA;AAFJ;AAFA;EAQI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAHJ;AAKI;EACE,+BAAA;EACA,2BAAA;AAHN;AAjBA;EAwBM,gBAAA;EACA,cAAA;AAJN;AArBA;EA8BI,mBAAA;EACA,YAAA;EACA,4BAAA;AANJ;AAQI;EACE,oCAAA;EACA,0BAAA;EACA,0CAAA;AANN;AA/BA;EA+CM,uBAAA;EACA,4CAAA;AAbN;AAnCA;EAmDQ,cAAA;EACA,gBAAA;EACA,eAAA;AAbR;AAxCA;EA0DM,aAAA;AAfN;AA3CA;EA8DU,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhBV;AAkBU;EACE,gBAAA;AAhBZ;AAwBE;EAAA;IAEI,mBAAA;EAtBJ;EAoBA;IAMI,aAAA;IACA,mBAAA;EAvBJ;EAgBA;IAUM,eAAA;EAvBN;AACF","sourcesContent":[".blood-chemistry-extractor {\n  \n  // 用户指南和上传器之间的间距\n  .ant-row + .ant-row {\n    margin-top: 32px;\n  }\n  \n  .page-header {\n    text-align: center;\n    margin-bottom: 32px;\n    padding: 32px 0;\n    background: var(--gradient-glass);\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(12px);\n    box-shadow: var(--shadow-md);\n    transition: all 0.3s ease;\n\n    &:hover {\n      box-shadow: var(--shadow-float);\n      transform: translateY(-2px);\n    }\n    \n    .ant-typography {\n      margin-bottom: 0;\n      color: #1e293b;\n    }\n  }\n\n  .ant-alert {\n    border-radius: 12px;\n    border: none;\n    box-shadow: var(--shadow-sm);\n    \n    &.ant-alert-info {\n      background: rgba(224, 242, 254, 0.6);\n      backdrop-filter: blur(8px);\n      border: 1px solid rgba(186, 230, 253, 0.5);\n    }\n  }\n\n  // Remove specific card overrides to let global styles take over\n  // or strictly enhance them\n  .ant-card {\n    // inherit global styles\n    \n    .ant-card-head {\n      background: transparent; // Glass header\n      border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n      \n      .ant-card-head-title {\n        color: #334155;\n        font-weight: 600;\n        font-size: 16px;\n      }\n    }\n    \n    .ant-card-body {\n      padding: 24px;\n      \n      ul {\n        li {\n          margin-bottom: 8px;\n          color: #64748b; // Slate 500\n          font-size: 14px;\n          line-height: 1.6;\n          \n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n  \n  // 响应式设计\n  @media (max-width: 768px) {\n    .ant-col {\n      margin-bottom: 16px;\n    }\n    \n    .page-header {\n      padding: 20px;\n      margin-bottom: 20px;\n      \n      .ant-typography h2 {\n        font-size: 24px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
